import React from 'react';

/**
 * Focuses the PIN step once, when it appears. Picking a seller unmounts the
 * roster tile that had focus, which would otherwise leave focus on `<body>`
 * (bos-seller#84); the step takes it instead, so a keyboard seller can see
 * where they are. Bind the returned ref to a `tabIndex={-1}` element that
 * names the step. Its focus indicator is the browser's own `:focus-visible`
 * ring: nothing restyles it through `className` (rulebook §6).
 *
 * The step is plain page content, not a dialog, so there is no overlay focus
 * management to wait for: an effect after mount is enough.
 */
export const usePinStepFocus = <
    T extends HTMLElement,
>(): React.RefObject<T | null> => {
    const ref = React.useRef<T>(null);

    React.useEffect(() => {
        ref.current?.focus();
    }, []);

    return ref;
};
